export default __webpack_public_path__ + "static/exclusiveTools-mobile-7eab2fe4e90abe8ad7cc56ccf563ded8.png";